import React, { useState, useEffect } from 'react';
import '../../styles/timesheetStyles/TimeSheets.css';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/HeaderFooter/Header';
import Footer from '../../components/HeaderFooter/Footer';
import { fetchTimesheetsProject, fetchTimesheetsEmployeeName } from '../../services/API';

const TimeSheetProject = () => {
  const [activeTab, setActiveTab] = useState('Project');
  const [selectedMembers, setSelectedMembers] = useState({});
  const [view, setView] = useState('Week'); 
  const [selectedYear, setSelectedYear] = useState(2024); 
  const [selectedMonth, setSelectedMonth] = useState('January');
  const [days, setDays] = useState([]);
  const [weeks, setWeeks] = useState([]);
  const [currentDayIndex, setCurrentDayIndex] = useState(0); 
  const [currentWeekIndex, setCurrentWeekIndex] = useState(0);
  const [currentMonthIndex, setCurrentMonthIndex] = useState(0); 
  const [projectData, setProjectData] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);
  const navigate = useNavigate();

  const handleCheckboxChange = (name) => {
    setSelectedMembers((prevSelectedMembers) => ({
      ...prevSelectedMembers,
      [name]: !prevSelectedMembers[name],
    }));
  };

  // useEffect(() => {
  //   const fetchProjectData = async () => {
  //     try {
  //       const response = await fetchTimesheetsProject();
  //       console.log('Project data:', response.data);
  //       setProjectData(response.data);
  //     } catch (error) {
  //       console.error("Error fetching project data:", error);
  //     }
  //   };

  //   const fetchEmployeeData = async () => {
  //     try {
  //       const response = await fetchTimesheetsEmployeeName();
  //       console.log('Employee data:', response.data);
        
  //       // Filter employees with Job_Title as 'Employee'
  //       const employees = response.data.filter(user => user.Job_Title === 'Employee');
  //       setEmployeeData(employees);
  //     } catch (error) {
  //       console.error("Error fetching employee data:", error);
  //     }
  //   };

  //   fetchProjectData();
  //   fetchEmployeeData();
  // }, []);

  useEffect(() => {
    const fetchProjectData = async () => {
      try {
        const response = await fetchTimesheetsProject();
        console.log('Project data:', response.data);
  
        // Ensure that `projectData` points to the correct array within the response
        if (response.data && response.data.projects) {
          setProjectData(response.data.projects);
        } else {
          console.error("Unexpected project data structure:", response.data);
          setProjectData([]); // Set to an empty array as a fallback
        }
      } catch (error) {
        console.error("Error fetching project data:", error);
        setProjectData([]); // Set to an empty array as a fallback
      }
    };
  
    const fetchEmployeeData = async () => {
      try {
        const response = await fetchTimesheetsEmployeeName();
        console.log('Employee data:', response.data);
  
        // Filter employees with Job_Title as 'Employee'
        if (response.data && response.data.projects) {
          setEmployeeData(response.data.projects);
        } else {
          console.error("Unexpected employee data structure:", response.data);
          setEmployeeData([]); 
        }
      } catch (error) {
        console.error("Error fetching employee data:", error);
        setEmployeeData([]);
      }
    };
  
    fetchProjectData();
    fetchEmployeeData();
  }, []);

  const redirectToTimesheetProjectDetails = () => {
    navigate('/timesheetprojectdetails');
  };

  const handleViewChange = (newView) => {
    setView(newView);
    
    // Reset indices when changing views
    if (newView === 'Day') {
      setCurrentDayIndex(0); // Reset to first page of days
    } 
    else if (newView === 'Month') {
      setCurrentMonthIndex(0); // Reset to first page of months
    }
    
    updateDaysAndWeeks(`${selectedMonth} ${selectedYear}`);
  };

  const handleMonthChange = (month) => {
    setSelectedMonth(month);
    updateDaysAndWeeks(`${month} ${selectedYear}`);
  };

  const handleYearChange = (event) => {
    const year = event.target.value;
    setSelectedYear(year);
    updateDaysAndWeeks(`${selectedMonth} ${year}`);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10; // Customize this value as needed

  const tasks = [
    { name: 'Chad Stevenson', date: '12th Jan, 2024', hours: '17 hrs', type: 'Service Call', status: 'In Progress' },
    { name: 'Ethan Anderson', date: '13th Jan, 2024', hours: '15 hrs', type: 'Project', status: 'Completed' },
    { name: 'Jamie Chambers', date: '14th Jan, 2024', hours: '10 hrs', type: 'Project', status: 'In Progress' },
    { name: 'Limia Foster', date: '5th Feb, 2024', hours: '8 hrs', type: 'Service Call', status: 'Completed' },
    { name: 'Marie Bennett', date: '11th Feb, 2024', hours: '12 hrs', type: 'Project', status: 'In Progress' },
    { name: 'Mark Williams', date: '20th Feb, 2024', hours: '14 hrs', type: 'Service Call', status: 'Completed' },
    { name: 'Peter Jackson', date: '28th Feb, 2024', hours: '16 hrs', type: 'Project', status: 'In Progress' },
    { name: 'Raj Choudhary', date: '8th Mar, 2024', hours: '20 hrs', type: 'Project', status: 'Completed' },
    { name: 'Sophia Turner', date: '15th Mar, 2024', hours: '19 hrs', type: 'Service Call', status: 'In Progress' },
    { name: 'Liam Martinez', date: '25th Mar, 2024', hours: '22 hrs', type: 'Project', status: 'Completed' },
    { name: 'Olivia Roberts', date: '1st Apr, 2024', hours: '13 hrs', type: 'Service Call', status: 'In Progress' },
    { name: 'Noah Davis', date: '10th Apr, 2024', hours: '18 hrs', type: 'Project', status: 'Completed' },
    { name: 'Emma Johnson', date: '20th Apr, 2024', hours: '15 hrs', type: 'Service Call', status: 'In Progress' },
    { name: 'Lucas White', date: '28th Apr, 2024', hours: '21 hrs', type: 'Project', status: 'Completed' },
    { name: 'Ava Thompson', date: '6th May, 2024', hours: '17 hrs', type: 'Service Call', status: 'In Progress' },
    { name: 'Mason Lee', date: '15th May, 2024', hours: '16 hrs', type: 'Project', status: 'Completed' },
    { name: 'Isabella Clark', date: '20th May, 2024', hours: '12 hrs', type: 'Service Call', status: 'In Progress' },
    { name: 'Elijah Walker', date: '1st Jun, 2024', hours: '14 hrs', type: 'Project', status: 'Completed' },
    { name: 'Amelia Hall', date: '7th Jun, 2024', hours: '10 hrs', type: 'Service Call', status: 'In Progress' },
    { name: 'James Allen', date: '16th Jun, 2024', hours: '15 hrs', type: 'Project', status: 'Completed' },
];  

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = tasks.slice(indexOfFirstRow, indexOfLastRow);

  const totalPages = Math.ceil(tasks.length / rowsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

 
  const renderPageNumbers = () => {
    const pageNumbers = [];

    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || (i >= currentPage - 1 && i <= currentPage + 1)) {
        pageNumbers.push(
          <button
            key={i}
            onClick={() => handlePageChange(i)}
            className={`page-number ${currentPage === i ? 'active' : ''}`}
          >
            {i}
          </button>
        );
      } else if (
        (i === currentPage - 2 && currentPage > 3) ||
        (i === currentPage + 2 && currentPage < totalPages - 2)
      ) {
        pageNumbers.push(<span key={i} className="dots">...</span>);
      }
    }

    return pageNumbers;
  };

  const months = [
    'January', 'February', 'March', 'April', 'May',
    'June', 'July', 'August', 'September', 'October',
    'November', 'December',
  ];

  const scrollWeeks = (direction) => {
    setCurrentWeekIndex((prevIndex) => {
      const totalWeeks = weeks.length;
      const newIndex = prevIndex + direction * 4; // Move by 4 weeks at a time
      return Math.max(0, Math.min(newIndex, totalWeeks - 4)); // Ensure the index stays within bounds
    });
  };

  const scrollMonths = (direction) => {
    setCurrentMonthIndex((prevIndex) => {
      const totalMonths = months.length; // Total number of months available
      const newIndex = prevIndex + direction * 6; // Adjust to show 6 months at a time
      // Clamping the value to valid range
      return Math.max(0, Math.min(newIndex, totalMonths - 6));
    });
  };

  const years = [2024, 2025, 2026, 2027, 2028, 2029, 2030]; // Add more years as needed

  // Updates the days and weeks based on the selected month and year
  const updateDaysAndWeeks = (monthYear) => {
    console.log(`Updating days and weeks for: ${monthYear}`);
  
    const monthDays = {
      'January': 31,
      'February': 29, // Leap year
      'March': 31,
      'April': 30,
      'May': 31,
      'June': 30,
      'July': 31,
      'August': 31,
      'September': 30,
      'October': 31,
      'November': 30,
      'December': 31,
    };
  
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
  
    // Parse the current month and year
    let [currentMonth, currentYear] = monthYear.split(" ");
    let currentMonthIndex = months.indexOf(currentMonth);
    let daysArray = [];
  
    const populateDaysForMonth = (month, year) => {
      const daysInMonth = monthDays[month];
      for (let i = 1; i <= daysInMonth; i++) {
        daysArray.push({ day: i, fullDate: `${i} ${month}` });
      }
    };
  
    // Start filling days for the current month
    populateDaysForMonth(currentMonth, currentYear);
  
    // Continue filling days for next months till December 31
    let nextMonthIndex = currentMonthIndex + 1;
    let nextYear = currentYear;
    while (daysArray.length < 366) {  // Maximum days in a leap year
      if (nextMonthIndex === 12) {
        nextMonthIndex = 0;
        nextYear = parseInt(nextYear) + 1; // Increment year after December
      }
      const nextMonth = months[nextMonthIndex];
      populateDaysForMonth(nextMonth, nextYear);
      nextMonthIndex++;
    }
  
    // Generate weeks as ranges of 7 days
    const weeksArray = [];
    for (let i = 0; i < daysArray.length; i += 7) {
      const startDay = daysArray[i].fullDate;
      const endDay = daysArray[Math.min(i + 6, daysArray.length - 1)].fullDate;
      weeksArray.push(`${startDay} - ${endDay}`);
    }
  
    // Update state with only day numbers for display
    const daysForDisplay = daysArray.map(day => day.day);
  
    setDays(daysForDisplay); // This will only display the day numbers
    setWeeks(weeksArray); // This will still show full date ranges (like "1 January - 7 January")
  };

  const getDaySuffix = (day) => {
    if (day > 3 && day < 21) return 'th';
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  };

  useEffect(() => {
    updateDaysAndWeeks(`${selectedMonth} ${selectedYear}`);
  }, [selectedMonth, selectedYear]);

  const scrollDays = (direction) => {
    const totalDays = days.length; // Total number of days available
    setCurrentDayIndex((prevIndex) => {
      const newIndex = prevIndex + direction * 10; // Assuming we show 10 days at a time
      return Math.max(0, Math.min(newIndex, totalDays - 10)); // Clamp value to valid range
    });
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    if (tab === 'Employee') {
      navigate('/timesheets');
    }
  };

  return (
    <div className="timesheet-container">
      <Header />
      <div className="content">
        <div className="tabs-container">
          <h2 className="tabs-title">TimeSheets</h2>
          
          <div className="tabs">
            <button className={`tab-item ${activeTab === 'Employee' ? 'active' : ''}`} onClick={() => handleTabClick('Employee')} >
              Employee
            </button>
            
            <button className={`tab-item ${activeTab === 'Project' ? 'active' : ''}`} onClick={() => handleTabClick('Project')} >
              Project
            </button>
          </div>

        </div>
      </div>

      <div className="timesheetScreen">
      <div className="team-container">
      <div className="team-title-container">
        <div className="team-title">{activeTab === 'Employee' ? 'Employee' : 'Project'}</div>
        <img src="/images/search.svg" alt="Search" className="search-icon" />
      </div>

      <div className="team-list">
  {activeTab === 'Employee'
    ? (Array.isArray(employeeData) &&
        employeeData.map((employee) => (
          <div className="team-member" key={`${employee.firstName} ${employee.lastName}`}>
            <img
              src={
                selectedMembers[`${employee.firstName} ${employee.lastName}`]
                  ? "../images/checkbox-checked.png"
                  : "../images/checkbox-unchecked.png"
              }
              alt={selectedMembers[`${employee.firstName} ${employee.lastName}`] ? "Checked" : "Unchecked"}
              className="member-icon"
              onClick={() =>
                handleCheckboxChange(`${employee.firstName} ${employee.lastName}`)
              }
            />
            <span>{`${employee.firstName} ${employee.lastName}`}</span>
          </div>
        )))

    : (Array.isArray(projectData) &&
        projectData.map((project) => (
          <div className="team-member" key={project.PROJECT_ID}>
            <img
              src={
                selectedMembers[project.PROJECT_ID]
                  ? "../images/checkbox-checked.png"
                  : "../images/checkbox-unchecked.png"
              }
              alt={selectedMembers[project.PROJECT_ID] ? "Checked" : "Unchecked"}
              className="member-icon"
              onClick={() => handleCheckboxChange(project.PROJECT_ID)}
            />
            <span>{project.Address}</span>
          </div>
        )))}
</div>

    </div>
        {/* <div className="team-container">
          
          <div className="team-title-container">
            <div className="team-title">Project</div>
            <img  src="/images/search.svg"  alt="Search" className="search-icon"  />
          </div>
          
          <div className="team-list">
            {projectData.map((project) => (
              <div className="team-member" key={project.PROJECT_ID}>
                <img
                  src={
                    selectedMembers[project.PROJECT_ID]
                      ? "../images/checkbox-checked.png"
                      : "../images/checkbox-unchecked.png"
                  }
                  alt={selectedMembers[project.PROJECT_ID] ? "Checked" : "Unchecked"}
                  className="member-icon"
                  onClick={() => handleCheckboxChange(project.PROJECT_ID)}
                />
                <span>{project.Address}</span>
              </div>
            ))}
          </div>
        </div> */}

        <div className="timesheet-header-container">
          
          <div className="timesheet-header">
            {view !== 'Month' ? (
              <select className="month-dropdown" value={selectedMonth} onChange={(e) => handleMonthChange(e.target.value)}>
                {months.map((month) => (
                  <option key={month} value={month}>{month}</option>
                ))}
              </select>
            ) : (
              <select className="year-dropdown" value={selectedYear} onChange={handleYearChange}>
                {years.map((year) => (
                  <option key={year} value={year}>{year}</option>
                ))}
              </select>
            )}
            <div className="view-toggle">
              <button 
                className={`toggle-button ${view === 'Day' ? 'active' : ''}`} 
                onClick={() => handleViewChange('Day')}
              >
                Day
              </button>
              <button 
                className={`toggle-button ${view === 'Week' ? 'active' : ''}`} 
                onClick={() => handleViewChange('Week')}
              >
                Week
              </button>
              <button 
                className={`toggle-button ${view === 'Month' ? 'active' : ''}`} 
                onClick={() => handleViewChange('Month')}
              >
                Month
              </button>
            </div>
          </div>

          <div className="period-selection">
            {view === 'Day' && (
              <>
                <button className="scroll-arrow" onClick={() => scrollDays(-1)}>&#9664;</button>
                {days.slice(currentDayIndex, currentDayIndex + 15).map(day => ( 
                  <div key={day} className="period">{day}</div>
                ))}
                <button className="scroll-arrow" onClick={() => scrollDays(1)}>&#9654;</button>
              </>
            )}

            {view === 'Week' && (
              <>
                <button className="scroll-arrow" onClick={() => scrollWeeks(-1)}>&#9664;</button>
                {weeks.slice(currentWeekIndex, currentWeekIndex + 4).map((week, index) => (
                  <div key={index} className="period" title={week}>{week}</div> // Add title for hover tooltip
                ))}
                <button className="scroll-arrow" onClick={() => scrollWeeks(1)}>&#9654;</button>
              </>
            )}

            {view === 'Month' && (
              <div className="months-list">
                <button onClick={() => scrollMonths(-1)} className="scroll-arrow">&#9664;</button>
                {months.slice(currentMonthIndex, currentMonthIndex + 10).map((month) => (
                  <div key={month} className="period"  onClick={() => handleMonthChange(month)} 
                    onContextMenu={(e) => {
                      e.preventDefault(); 
                      handleMonthChange(month); // Handle the right-click to change month
                    }}
                    tabIndex={0} // Make it focusable for accessibility
                    onKeyDown={(e) => { if (e.key === 'Enter') { handleMonthChange(month);}}} 
                  >
                    {month}
                  </div>
                ))}
                <button onClick={() => scrollMonths(1)} className="scroll-arrow">&#9654;</button>
              </div>
            )}

          </div>

          <table className="timesheet-table">
            <thead>
              <tr>
                <th> <img src="/images/servicecall.svg" alt="Service Call Icon" className="label-icon" /> Name </th>
                <th> <img src="/images/date.png" alt="Date Icon" className="label-icon" /> Date </th>
                <th> <img src="/images/worker.png" alt="Time Icon" className="label-icon" /> Type </th>
                <th> <img src="/images/time.png" alt="Tasks Icon" className="label-icon" /> Hours </th>
                <th> <img src="/images/status.svg" alt="Type Icon" className="label-icon" /> Status </th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              {currentRows.map((item, index) => (
                <tr key={index}>
                  <td><b>{item.name}</b></td>
                  <td>{item.date}</td>
                  <td>{item.type}</td>
                  <td>{item.hours}</td>
                  <td>
                      {item.status === 'Completed' ? (
                        <img src="images/complete.svg" alt="Completed" style={{ marginRight: '5px'}} className="status-icon"/>
                      ) : (
                        <img src="/images/inprogress.svg" alt="In Progress" style={{ marginRight: '5px' }}className="status-icon" />
                      )}
                      <span className= "status-text" style={{ color: item.status === 'Completed' ? '#8ABE14' : '#E59A0A'}}>
                        {item.status}
                      </span>
                  </td>  
                                 
                  <td><button onClick={redirectToTimesheetProjectDetails}><img src="/images/arrow.png" alt="Next Icon" className="next-icon"/></button></td>
                </tr>
              ))}
            </tbody>

          </table>
        </div>
      </div>

      <div className="pagination">
            {renderPageNumbers()}
            <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} className="pagination-next">
              Next
            </button>
      </div>

      <div className="button-section">
        <button className="export-button" > Export Excel </button>
        <button className="download-button" > Download Pdf </button>
      </div>

      <Footer />

    </div>
  );
};

export default TimeSheetProject;
